export const routes = [{
  path: '/tipoSolucao',
  component: () =>
    import(/* webpackChunkName: "ur" */ './components/List'),
  name: 'tipoSolucao.list',
  meta: {
    requiresAuth: true
  }
}]
